export const emitAngularEvent = (eventName: string, eventData: Object): void => {
  const angularScope = window.angular.element(document.body).scope();

  if (angularScope) {
    angularScope.$root.$emit(eventName, eventData);
  }
}

